import { Flex, Text } from '@lego/klik-ui';
import { TextHeader } from './TextHeader';

type Props = {
  title: string;
};

export const DetailsHeader = ({ title }: Props) => (
  <Flex gap={2} mb={4}>
    <TextHeader tagLevel="h3" title={title} />
    <Text color="gray" fontSize="xs" fontWeight="medium">
      Details
    </Text>
  </Flex>
);
